import { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import useRolesStore from 'store/roles';
import useUsersStore from 'store/users';
import { cloneDeep } from 'lodash';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';


const userModel = {
  fullName: undefined,
  email: undefined,
  phoneNumber: undefined,
  roles: []
}

function EditModal({user, close, dismiss}) {
  const [tempUser, setTempUser] = useState();
  const [rolesStore] = useRolesStore();
  const [, usersStoreActions] = useUsersStore();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();
  const isNew = !user;

  useEffect(() => {
    setTempUser(cloneDeep(user || userModel));
  }, [user])

  async function finish() {
    setLoading(true);
    const res = await usersStoreActions.save(tempUser);
    setLoading(false);
    if (!res) {
      close();
    } else {
      setErrors(res);
    }
  }

  function toggleRole(event) {
    const value = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      tempUser.roles = [...tempUser.roles, value];
    } else {
      tempUser.roles = tempUser.roles.filter((item) => item !== value);
    }
  }

  if (!tempUser) return null;

  return (
    <I18nProvider i18n={i18n}>
      <header>
        <h3>
          {!isNew ?
            <><Trans>Configure User</Trans>: <strong>{tempUser.fullName}</strong></> :
            <Trans>Configure New User</Trans>
          }
        </h3>
      </header>
      <section>
        <Banner show={errors} status="alert" small={true}>
          <Trans>There was an error saving this user.</Trans>
        </Banner>
        <ul className="form">
          <li className="flex">
            <label htmlFor="userName">
              <Trans>Username</Trans>
            </label>
            <input
              type="text"
              id="username"
              name="username"
              defaultValue={tempUser.username}
              onChange={event => tempUser.username = event.target.value}
              className={errors?.username ? 'error' : null}
            />
            {errors?.username?.length ?
              <p className="error-text">{errors.username}</p>
            : null}
          </li>
          {isNew ? <li className="flex">
            <label htmlFor="password">
              <Trans>Password</Trans>
            </label>
            <input
              type="password"
              id="password"
              name="password"
              defaultValue={tempUser.password}
              onChange={event => tempUser.password = event.target.value}
              className={errors?.password ? 'error' : null}
            />
            {errors?.password?.length ?
              <p className="error-text">{errors.password}</p>
            : null}
          </li> : <></>}
          <li className="flex">
            <label htmlFor="fullName">
              <Trans>Full Name</Trans>
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              defaultValue={tempUser.fullName}
              onChange={event => tempUser.fullName = event.target.value}
              className={errors?.fullName ? 'error' : null}
            />
            {errors?.fullName?.length ?
              <p className="error-text">{errors.fullName}</p>
            : null}
          </li>
          <li className="flex">
            <label htmlFor="email">
              <Trans>Email</Trans>
            </label>
            <input
              type="text"
              id="email"
              name="email"
              defaultValue={tempUser.email}
              onChange={event => tempUser.email = event.target.value}
              className={errors?.email ? 'error' : null}
            />
            {errors?.email?.length ?
              <p className="error-text">{errors.email}</p>
            : null}
          </li>
          <li>
            <label htmlFor="phoneNumber">
              <Trans>Phone Number</Trans>
            </label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              defaultValue={tempUser.phoneNumber}
              onChange={event => tempUser.phoneNumber = event.target.value}
              className={errors?.phoneNumber ? 'error' : null}
            />
            {errors?.phoneNumber?.length ?
              <p className="error-text">{errors.phoneNumber}</p>
            : null}
          </li>
          <li className="flex">
            <label htmlFor="roles">
              <Trans>Roles</Trans>
            </label>
            <div className="input-group">
              {rolesStore.roles.map(role =>
                <label key={`check-role-${role.id}`}>
                  <input
                    type="checkbox"
                    value={role.id}
                    defaultChecked={tempUser.roles.includes(role.id)}
                    onClick={toggleRole}
                    className={errors?.roles ? 'error' : null}
                  />
                  {role.name}
                </label>
              )}
            </div>
            {errors?.roles?.length ?
              <p className="error-text">{errors.roles}</p>
            : null}
          </li>
        </ul>
      </section>
      <footer>
        <button onClick={dismiss}>
          <Trans>Cancel</Trans>
        </button>
        <button
          className={`primary ${loading ? 'processing' : ''}`}
          onClick={finish}
          disabled={loading}
        >
          <Trans>Save</Trans>
        </button>
      </footer>
    </I18nProvider>
  );
}

export default EditModal;
